import { CallToAction } from '@/graphql/types';
import { filter } from 'lodash';
import isValidCta from '@/utils/isValidCta';

const MAX_FEATURED_LINKS = 5;

export function useGetFeaturedLinks(ctas?: CallToAction[], featuredLinkIds?: string[]) {
  const allLinks = (ctas ?? []).filter(isValidCta);

  const featuredLinks = filter(allLinks, link => featuredLinkIds!.includes(link?.id || '')) || [];
  const maxFeaturedLinksReached = featuredLinkIds?.length === MAX_FEATURED_LINKS;

  return {
    allLinks,
    featuredLinks,
    maxFeaturedLinksReached,
  };
}
